import $ from 'jquery';

export default class CustomTab {
    constructor(el) {
        this.DOM = { el: el };
        this.target = this.DOM.el.dataset.tabTarget;

        this.initEvents();
    }

    initEvents() {
        /* Add event listener */
        this.DOM.el.addEventListener('click', () => {
            $(this.target).tab('show');
        });
    }
}

const tabTargetNodes = Array.from(document.querySelectorAll('[data-tab-target]'));
if (tabTargetNodes !== null) {
    tabTargetNodes.forEach((node) => { new CustomTab(node); });
}
